function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["react-timer-hook"] = t(require("react")) : e["react-timer-hook"] = t(e.react);
}("undefined" != typeof self ? self : this, function (e) {
  return function () {
    "use strict";

    var t = {
      156: function _(t) {
        t.exports = e;
      }
    },
        r = {};

    function o(e) {
      var n = r[e];
      if (void 0 !== n) return n.exports;
      var s = r[e] = {
        exports: {}
      };
      return t[e](s, s.exports, o), s.exports;
    }

    o.d = function (e, t) {
      for (var r in t) {
        o.o(t, r) && !o.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var n = {};
    return function () {
      o.r(n), o.d(n, {
        "default": function _default() {
          return l;
        },
        useStopwatch: function useStopwatch() {
          return u;
        },
        useTime: function useTime() {
          return m;
        },
        useTimer: function useTimer() {
          return c;
        }
      });
      var e = o(156);

      var t = /*#__PURE__*/function () {
        function t() {
          _classCallCheck(this, t);
        }

        _createClass(t, null, [{
          key: "expiryTimestamp",
          value: function expiryTimestamp(e) {
            var t = new Date(e).getTime() > 0;
            return t || console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings", e), t;
          }
        }, {
          key: "onExpire",
          value: function onExpire(e) {
            var t = e && "function" == typeof e;
            return e && !t && console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function", e), t;
          }
        }]);

        return t;
      }();

      var r = /*#__PURE__*/function () {
        function r() {
          _classCallCheck(this, r);
        }

        _createClass(r, null, [{
          key: "getTimeFromSeconds",
          value: function getTimeFromSeconds(e) {
            var t = Math.ceil(e),
                r = Math.floor(t / 86400),
                o = Math.floor(t % 86400 / 3600),
                n = Math.floor(t % 3600 / 60);
            return {
              totalSeconds: t,
              seconds: Math.floor(t % 60),
              minutes: n,
              hours: o,
              days: r
            };
          }
        }, {
          key: "getSecondsFromExpiry",
          value: function getSecondsFromExpiry(e, t) {
            var r = e - new Date().getTime();

            if (r > 0) {
              var _e = r / 1e3;

              return t ? Math.round(_e) : _e;
            }

            return 0;
          }
        }, {
          key: "getSecondsFromPrevTime",
          value: function getSecondsFromPrevTime(e, t) {
            var r = new Date().getTime() - e;

            if (r > 0) {
              var _e2 = r / 1e3;

              return t ? Math.round(_e2) : _e2;
            }

            return 0;
          }
        }, {
          key: "getSecondsFromTimeNow",
          value: function getSecondsFromTimeNow() {
            var e = new Date();
            return e.getTime() / 1e3 - 60 * e.getTimezoneOffset();
          }
        }, {
          key: "getFormattedTimeFromSeconds",
          value: function getFormattedTimeFromSeconds(e, t) {
            var _r$getTimeFromSeconds = r.getTimeFromSeconds(e),
                o = _r$getTimeFromSeconds.seconds,
                n = _r$getTimeFromSeconds.minutes,
                s = _r$getTimeFromSeconds.hours;

            var i = "",
                a = s;
            return "12-hour" === t && (i = s >= 12 ? "pm" : "am", a = s % 12), {
              seconds: o,
              minutes: n,
              hours: a,
              ampm: i
            };
          }
        }]);

        return r;
      }();

      function s(t, r) {
        var o = (0, e.useRef)();
        (0, e.useEffect)(function () {
          o.current = t;
        }), (0, e.useEffect)(function () {
          if (!r) return function () {};
          var e = setInterval(function () {
            o.current && o.current();
          }, r);
          return function () {
            return clearInterval(e);
          };
        }, [r]);
      }

      var i = 1e3;

      function a(e) {
        if (!t.expiryTimestamp(e)) return null;
        var o = r.getSecondsFromExpiry(e),
            n = Math.floor(1e3 * (o - Math.floor(o)));
        return n > 0 ? n : i;
      }

      function c() {
        var _ref = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            o = _ref.expiryTimestamp,
            n = _ref.onExpire,
            _ref$autoStart = _ref.autoStart,
            c = _ref$autoStart === void 0 ? !0 : _ref$autoStart;

        var _ref2 = (0, e.useState)(o),
            _ref3 = _slicedToArray(_ref2, 2),
            u = _ref3[0],
            m = _ref3[1],
            _ref4 = (0, e.useState)(r.getSecondsFromExpiry(u)),
            _ref5 = _slicedToArray(_ref4, 2),
            l = _ref5[0],
            d = _ref5[1],
            _ref6 = (0, e.useState)(c),
            _ref7 = _slicedToArray(_ref6, 2),
            p = _ref7[0],
            f = _ref7[1],
            _ref8 = (0, e.useState)(c),
            _ref9 = _slicedToArray(_ref8, 2),
            g = _ref9[0],
            S = _ref9[1],
            _ref10 = (0, e.useState)(a(u)),
            _ref11 = _slicedToArray(_ref10, 2),
            T = _ref11[0],
            y = _ref11[1],
            h = (0, e.useCallback)(function () {
          t.onExpire(n) && n(), f(!1), y(null);
        }, [n]),
            x = (0, e.useCallback)(function () {
          f(!1);
        }, []),
            v = (0, e.useCallback)(function (e) {
          var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          y(a(e)), S(t), f(t), m(e), d(r.getSecondsFromExpiry(e));
        }, []),
            F = (0, e.useCallback)(function () {
          var e = new Date();
          e.setMilliseconds(e.getMilliseconds() + 1e3 * l), v(e);
        }, [l, v]),
            b = (0, e.useCallback)(function () {
          g ? (d(r.getSecondsFromExpiry(u)), f(!0)) : F();
        }, [u, g, F]);

        return s(function () {
          T !== i && y(i);
          var e = r.getSecondsFromExpiry(u);
          d(e), e <= 0 && h();
        }, p ? T : null), _objectSpread(_objectSpread({}, r.getTimeFromSeconds(l)), {}, {
          start: b,
          pause: x,
          resume: F,
          restart: v,
          isRunning: p
        });
      }

      function u() {
        var _ref12 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = _ref12.autoStart,
            o = _ref12.offsetTimestamp;

        var _ref13 = (0, e.useState)(r.getSecondsFromExpiry(o, !0) || 0),
            _ref14 = _slicedToArray(_ref13, 2),
            n = _ref14[0],
            i = _ref14[1],
            _ref15 = (0, e.useState)(new Date()),
            _ref16 = _slicedToArray(_ref15, 2),
            a = _ref16[0],
            c = _ref16[1],
            _ref17 = (0, e.useState)(n + r.getSecondsFromPrevTime(a || 0, !0)),
            _ref18 = _slicedToArray(_ref17, 2),
            u = _ref18[0],
            m = _ref18[1],
            _ref19 = (0, e.useState)(t),
            _ref20 = _slicedToArray(_ref19, 2),
            l = _ref20[0],
            d = _ref20[1];

        s(function () {
          m(n + r.getSecondsFromPrevTime(a, !0));
        }, l ? 1e3 : null);
        var p = (0, e.useCallback)(function () {
          var e = new Date();
          c(e), d(!0), m(n + r.getSecondsFromPrevTime(e, !0));
        }, [n]),
            f = (0, e.useCallback)(function () {
          i(u), d(!1);
        }, [u]),
            g = (0, e.useCallback)(function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          var o = r.getSecondsFromExpiry(e, !0) || 0,
              n = new Date();
          c(n), i(o), d(t), m(o + r.getSecondsFromPrevTime(n, !0));
        }, []);
        return _objectSpread(_objectSpread({}, r.getTimeFromSeconds(u)), {}, {
          start: p,
          pause: f,
          reset: g,
          isRunning: l
        });
      }

      function m() {
        var _ref21 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = _ref21.format;

        var _ref22 = (0, e.useState)(r.getSecondsFromTimeNow()),
            _ref23 = _slicedToArray(_ref22, 2),
            o = _ref23[0],
            n = _ref23[1];

        return s(function () {
          n(r.getSecondsFromTimeNow());
        }, 1e3), _objectSpread({}, r.getFormattedTimeFromSeconds(o, t));
      }

      function l(t) {
        if ((0, e.useEffect)(function () {
          console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead");
        }, []), t.expiryTimestamp) {
          var _e3 = c(t);

          return _objectSpread(_objectSpread({}, _e3), {}, {
            startTimer: _e3.start,
            stopTimer: _e3.pause,
            resetTimer: function resetTimer() {}
          });
        }

        var r = u(t);
        return _objectSpread(_objectSpread({}, r), {}, {
          startTimer: r.start,
          stopTimer: r.pause,
          resetTimer: r.reset
        });
      }
    }(), n;
  }();
});